<template>
  <b-modal
    dialog-class="news-modal-wrapper"
    body-class="news-modal-body"
    footer-class="news-modal-footer"
    :header-class="[
      'news-modal-header',
      {
        'news-modal-header_admin': $auth.user().isAdmin,
      },
    ]"
    modal-class="news-modal"
    content-class="news-modal-content"
    id="news-modal"
    centered
    scrollable
  >
    <template #modal-header="{ close }">
      <subtitle>Последние новости</subtitle>
      <button class="news-close-button" @click="close()" />
    </template>

    <main-button
      @click="$emit('addNewsButtonClick')"
      color="secondary"
      class="news-add-button"
      v-if="$auth.user().isAdmin"
      >Добавить новость</main-button
    >

    <div class="news-block" :key="element.id" v-for="element in news">
      <div class="news-block-header">
        <p class="news-subtitle">{{ element.author }}</p>
        <p class="news-date">{{ parseInt(element.date) | moment("from", "now") }}</p>
      </div>
      <div v-html="element.text" />
    </div>

    <template #modal-footer="{ ok }">
      <button class="news-footer-button" @click="ok()">Ок</button>
    </template>
  </b-modal>
</template>

<script>
import MainButton from "../ui/MainButton.vue";
import Subtitle from "../ui/Subtitle.vue";
export default {
  props: {
    news: {
      type: Array,
      require: false,
    },
  },
  components: {
    "main-button": MainButton,
    Subtitle,
  },
};
</script>

<!-- Scoped не получится применить т.к. тогда классы компонентов модалки не применятся -->
<style>
.news-modal-wrapper {
  min-width: 600px;
}

@media screen and (max-width: 768px) {
  .news-modal-wrapper {
    min-width: 75%;
  }
}

.news-modal-body {
  padding: 0 24px 32px;
}

.news-modal-content {
  max-height: 80vh !important;
}

.news-modal-header {
  border: none;
  padding: 24px 24px 32px;
}

.news-modal-header_admin {
  padding-bottom: 16px;
}

.news-close-button {
  width: 16px;
  height: 16px;
  border: none;
  outline: none;
  cursor: pointer;
  background: url("../../files/close-icon.svg");
  opacity: 1;
  transition: opacity 0.15s ease-out;
}

.news-close-button:hover {
  opacity: 0.75;
}

.news-block {
  margin-bottom: 32px;
  color: black;
}

.news-block:last-of-type {
  margin-bottom: 0;
}

.news-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.news-subtitle {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #000;
  margin-bottom: 0;
}

.news-date {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-3-color);
  margin-bottom: 0;
}

.news-modal-footer {
  justify-content: flex-start;
  padding: 16px 24px;
  border: none;
}

.news-footer-button {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--white-color);
  padding: 10px 24px;
  background-color: var(--primary-color);
  border: none;
  border-radius: 4px;
  margin: 0;
  transition: background-color 0.15s ease-out;
  margin-right: 16px;
}

.news-footer-button:hover {
  background-color: var(--primary-hover-color);
  color: var(--white-color);
}
.news-add-button {
  margin-bottom: 16px;
}
</style>
;
